import {Injectable} from '@angular/core';
import { RecaptchaService } from '../../networking/services/recaptcha/recaptcha.service';
import { SessionStorageManager } from '../session-storage/session-storage.manager';
import { recaptchaEnv } from 'src/environments/colombia/recaptcha.env';

declare let grecaptcha: {
  enterprise: {
    execute: (key: string, options: {action: string}) => Promise<string>;
  };
};

@Injectable({
  providedIn: 'root',
})
export class RecaptchaManager {
  constructor(private recaptchaService: RecaptchaService,
              private sessionStorageManager: SessionStorageManager
   ) {}


  getEvaluationRecaptcha(data:object) {
   return this.recaptchaService.getEvaluationRecaptcha(data);
  }

  actionRecaptcha(actionValue:string) {
    return grecaptcha.enterprise.execute(recaptchaEnv.recaptchaSiteKey, {action: actionValue});
  }

  getConfigurationRecaptcha(){
   return this.recaptchaService.getConfigurationRecaptcha();
  }

  async transformHashSHA256(data: string) {
    try {
      const encoder = new TextEncoder();
      const dataBuffer = encoder.encode(data);
      const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    } catch (error) {
      throw new Error('Failed to compute SHA-256 hash');
    }
  }

  getCustomerIpAddress(){
    return this.sessionStorageManager.get('ipUser');
   }

}